import { toNumericPrice } from 'Src/types/payment';
import { castAs } from 'Src/types/cast-helpers';
import React from 'react';
import { useDisclosure } from 'Src/hooks/use-disclosure/useDisclosure';
import { TemplateString } from 'Components/frameworks/template-string/TemplateString';
import { classnames } from 'Utils/classnames/classnames.utils';
import { Icon } from 'Components/frameworks/icon/Icon';
import { ICONS } from 'Components/utils/icon/icons';
import { usePledgSchedule } from './usePledgSchedule';
import { PledgTimelinesModal } from './PledgTimelinesModal';

export const PledgPrice = ({
  price,
  label,
  iconClassname,
}: {
  price: Price | number;
  label?: string;
  iconClassname: string;
}) => {
  const numericPrice = toNumericPrice(price);
  const { monthlyPayment, fees, firstPayment, installment } = usePledgSchedule({
    price: numericPrice,
  });
  const { isOpen, onClose, onOpen } = useDisclosure();

  const isSinglePrice = !label;

  return (
    <React.Fragment>
      <span className="none cursor-pointer text-14" role="button" aria-hidden="true">
        <TemplateString
          template={label || '{monthlyPayment}'}
          valuesClassName={{
            firstPayment: 'font-bold text-sienna',
            monthlyPayment: classnames({
              ['font-bold text-sienna']: !isSinglePrice,
              ['text-12']: isSinglePrice,
            }),
            fees: 'font-bold text-sienna',
          }}
          values={{ firstPayment, monthlyPayment, fees }}
        />
        <span
          className={classnames('absolute', iconClassname)}
          onClick={(e) => {
            e.preventDefault();
            onOpen();
          }}
        >
          <Icon
            name={ICONS.INFORMATION}
            width="1.5rem"
            className={classnames({
              ['text-sienna']: !isSinglePrice,
            })}
          />
        </span>
      </span>
      {isOpen && (
        <PledgTimelinesModal
          onCloseModal={onClose}
          installment={castAs<Array<{ amount_cents: number; fees: number; payment_date: string }>>(
            installment,
          )}
          total={numericPrice}
        />
      )}
    </React.Fragment>
  );
};
